import MarqueeLib from "react-fast-marquee";
import { useReducedMotion } from "framer-motion";

const ITEMS = [
  "Let’s Elaborate · Wednesdays",
  "The Program · Saturdays",
  "With SHi",
  "Shi Sips",
  "Music",
  "Premieres Thursday, December 3, 2026",
];

export default function Marquee() {
  const reduce = useReducedMotion();
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-corduroy bg-wine py-4 md:py-5 overflow-hidden"
    >
      <MarqueeLib speed={35} play={!reduce} gradient={false} aria-hidden="true">
        {ITEMS.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display uppercase tracking-[0.3em] text-cream text-lg md:text-2xl px-6 md:px-10 whitespace-nowrap">
              {item}
            </span>
            <span className="text-gold text-sm md:text-base">&#10022;</span>
          </span>
        ))}
      </MarqueeLib>
    </div>
  );
}
